export default "<p *ngIf=\"this.userService.currentUserValue\">Logging out...</p>\r\n";